/*
 *		Copyright (c) 2011-2020 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes').directive('accCopyLink', ['$translate', function ($translate) {
    return {
        replace: true,
        restrict: 'E',
        transclude: true,
        template: '<button type="button" class="btn-copy-link btn-link">\
            <i class="icon-acc-copy_link"></i>\
            {{ \'copy_link_button_text\' | translate }}\
        </button>',
        scope: {
            text: '=',
            tooltipPosition: '@'
        },
        link: function ($scope, element) {
            var tootipHideTimeout = 0;
            var tooltip = element.tooltip({
                placement: $scope.tooltipPosition || 'right',
                title: $translate.instant('copy_link_button_tooltip_success'),
                trigger: 'manual'
            }).data('bs.tooltip');

            var clipboard = new ClipboardJS(element.get(0), {
                text: function () {
                    return $scope.text;
                }
            });

            clipboard.on('success', function () {
                tooltip.show();

                if (tootipHideTimeout) {
                    clearTimeout(tootipHideTimeout);
                }

                tootipHideTimeout = setTimeout(function () {
                    tooltip.hide();
                }, 3000);
            });

            clipboard.on('error', function (error) {
                console.error(error);
            });

            element.on('$destroy', function () {
                clipboard.destroy();
                tooltip.destroy();
            });
        }
    };
}]);
